import { useAppDispatch } from 'app/store';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { TextField, MenuItem, Button, Box } from '@mui/material';
import { Controller, useForm, SubmitHandler } from 'react-hook-form';
import { useAddParticipantMutation, useGetParticipantsQuery } from 'features/getParticipants/api/getParticipantsApi';

type FormDataType = {
  id: number;
  participant: string;
  title: string;
};

export const AddParticipantDrawer = (promoId: any) => {
  const dispatch = useAppDispatch();

  const { data: participants } = useGetParticipantsQuery({
    page: 1,
    size: 100,
    search: '',
  });
  const [addParticipantRequest] = useAddParticipantMutation();
  const { control, handleSubmit, getValues } = useForm<FormDataType>({
    defaultValues: {
      id: 0,
      participant: '',
      title: '',
    },
  });
  const onSubmit: SubmitHandler<FormDataType> = () => {
    const data = getValues();
    const { promoId: id } = promoId;
    addParticipantRequest({
      id,
      body: {
        participant_id: data.participant.toString(),
      },
    }).then(() => {
      dispatch(setDrawerOpen(false));
    });
  };

  return (
    <>
      <div>
        <div style={{ marginBottom: '20px' }}>Добавить новую торговую точку</div>
        <Controller
          name="participant"
          control={control}
          rules={{
            required: 'Торговая точка обязательна',
          }}
          render={({ field }) => (
            <TextField
              select
              type="text"
              label="Торговая точка"
              placeholder=""
              fullWidth
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                marginBottom: '24px',
              }}
              {...field}
            >
              {participants && participants.items ? (
                participants?.items.map((item) => (
                  <MenuItem
                    value={item.id}
                    key={item.id}
                  >
                    {item.title}
                  </MenuItem>
                ))
              ) : (
                <MenuItem>loading</MenuItem>
              )}
            </TextField>
          )}
        />
      </div>

      <Box
        sx={{
          display: 'flex',
          marginTop: '30px',
        }}
      >
        <Button
          variant="contained"
          sx={{ textTransform: 'none' }}
          onClick={handleSubmit(onSubmit)}
        >
          Добавить
        </Button>
      </Box>
    </>
  );
};
